import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["content"]
const _hoisted_2 = ["href"]
const _hoisted_3 = ["content"]
const _hoisted_4 = ["content"]
const _hoisted_5 = ["content"]
const _hoisted_6 = ["content"]
const _hoisted_7 = ["content"]
const _hoisted_8 = ["content"]
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("title", null, _toDisplayString(_ctx.title), 1 /* TEXT */),
    _createElementVNode("meta", {
      name: "robots",
      content: _ctx.robots
    }, null, 8 /* PROPS */, _hoisted_1),
    _createElementVNode("link", {
      rel: "canonical",
      href: _ctx.canonical
    }, null, 8 /* PROPS */, _hoisted_2),
    _createElementVNode("meta", {
      name: "description",
      content: _ctx.description
    }, null, 8 /* PROPS */, _hoisted_3),
    (_ctx.showPrerenderStatusCode)
      ? (_openBlock(), _createElementBlock("meta", {
          key: 0,
          name: "prerender-status-code",
          content: _ctx.prerenderStatusCode
        }, null, 8 /* PROPS */, _hoisted_4))
      : _createCommentVNode("v-if", true),
    (_ctx.showPrerenderHeader)
      ? (_openBlock(), _createElementBlock("meta", {
          key: 1,
          name: "prerender-header",
          content: _ctx.prerenderHeader
        }, null, 8 /* PROPS */, _hoisted_5))
      : _createCommentVNode("v-if", true),
    _createElementVNode("meta", {
      property: "og:title",
      content: _ctx.title
    }, null, 8 /* PROPS */, _hoisted_6),
    _cache[0] || (_cache[0] = _createElementVNode("meta", {
      property: "og:type",
      content: "website"
    }, null, -1 /* CACHED */)),
    _createElementVNode("meta", {
      property: "og:url",
      content: _ctx.canonical
    }, null, 8 /* PROPS */, _hoisted_7),
    _createElementVNode("meta", {
      property: "og:description",
      content: _ctx.description
    }, null, 8 /* PROPS */, _hoisted_8),
    _cache[1] || (_cache[1] = _createElementVNode("meta", {
      property: "og:image",
      content: "https://monet-prtl-co.imgix.net/Shared/SearchPage/BA_Portal_no%20text_illustration.png?auto=compress"
    }, null, -1 /* CACHED */)),
    (_ctx.showRelPrev)
      ? (_openBlock(), _createElementBlock("link", {
          key: 2,
          rel: "prev",
          href: _ctx.relPrev
        }, null, 8 /* PROPS */, _hoisted_9))
      : _createCommentVNode("v-if", true),
    (_ctx.showRelNextPage2)
      ? (_openBlock(), _createElementBlock("link", {
          key: 3,
          rel: "next",
          href: _ctx.relNextPage2
        }, null, 8 /* PROPS */, _hoisted_10))
      : _createCommentVNode("v-if", true),
    (_ctx.showRelNextPage3)
      ? (_openBlock(), _createElementBlock("link", {
          key: 4,
          rel: "next",
          href: _ctx.relNextPage3
        }, null, 8 /* PROPS */, _hoisted_11))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}